// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

/////////////////////////////////////////
// TENANT SETTINGS SCHEMA
/////////////////////////////////////////

export const TenantSettingsSchema = z.object({
  /**
   * prisma-lint-ignore-model model-name-grammatical-number
   */
  id: z.string(),
  tenantId: z.string().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  onboardingCompletedAt: z.coerce.date().nullable(),
  byocOnboardingCompletedAt: z.coerce.date().nullable(),
  isCustomer: z.boolean(),
  povStatus: z.string().nullable(),
  priority: z.string(),
  frequency: z.string(),
  researcherEmail: z.string().nullable(),
  salesOwnerEmail: z.string().nullable(),
  csOwnerEmail: z.string().nullable(),
  expectedApplicationCount: z.number().int().nullable(),
})

export type TenantSettings = z.infer<typeof TenantSettingsSchema>

export default TenantSettingsSchema;
